var BREAKPOINTS = Object.freeze([/* These BREAKPOINTS are in a specific order and based on the PageWrapper. Touch with care */
{
  label: 'extra-wide',
  width: 1608
}, {
  label: 'wide',
  width: 848
}, {
  label: 'medium',
  width: 692
}, {
  label: 'narrow',
  width: 0
}]);
var getCardType = function getCardType(width, type) {
  if (['mini', 'narrow'].includes(type)) {
    return type;
  }
  for (var i = 0, length = BREAKPOINTS.length; i < length; i++) {
    var breakpoint = BREAKPOINTS[i];
    if (Number(width) >= breakpoint.width) {
      return breakpoint.label;
    }
  }
  return 'wide';
};
export { BREAKPOINTS, getCardType };